var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const Check = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-check ${className}`} {...other}>
      <g>
        <path d="M14.07 3.446l.353.354a.5.5 0 010 .707L6.236 12.7 1.573 7.99a.5.5 0 01.007-.707l.356-.35a.5.5 0 01.638-.053l.07.059 3.6 3.628 7.118-7.121a.5.5 0 01.707 0z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default Check;
